<template>
  <div :class="[_.empty, noMargin && _.noMargin]">
    <img :src="iconUrl" :class="_.icon" :style="iconStyle" />
    <div :class="_.message">
      {{ message }}
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({
    props: {
      // 图标
      icon: {
        type: String,
        default: require('./images/列表.png'),
      },

      // 类型：地址，购物车，列表，券包，搜索，网络，已下架
      type: {
        type: String,
        default: '',
      },

      // 图标宽度
      iconWidth: {
        type: Number,
        default: 150,
      },

      // 信息
      message: {
        type: String,
        default: '暂无数据',
      },

      // 无边距
      noMargin: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      iconUrl() {
        return this.type
          ? {
              // @index('./images/*.png', f => `'${f.name}': require('${f.path}${f.ext}'),`)
              列表: require('./images/列表.png'),
              // @endindex
            }[this.type]
          : this.icon
      },
      iconStyle() {
        return {
          width: this.$transformPx(this.iconWidth),
        }
      },
    },
  })
</script>

<style lang="scss" module="_">
  .empty {
    padding: 100px 0;
    text-align: center;
    user-select: none;
    -webkit-touch-callout: none;
    display: flex;
    flex-direction: column;
    align-items: center;

    .message {
      max-width: 80%;
      font-size: 14px;
      color: #999999;
    }

    .actions {
      margin-top: 30px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    &.noMargin {
      padding: 0;
    }
  }
</style>
